import * as yup from 'yup';
import moment from 'moment';
import { ActivityType } from '../../UserActivityTypes';

export default yup.object().shape({
  date: yup
    .string()
    .required('Please, insert a valid date and time.')
    .test('is-future-date', 'Date cannot be in the future.', value => {
      if (!value) {
        // Let the .required() test handle it
        return true;
      }

      return moment.utc(value).isBefore(moment.utc());
    }),

  activityName: yup.string().when('activityType', {
    is: status => status === ActivityType.OtherActivity,
    then: yup.string().required('Please, insert the name of the activity.'),
  }),
});
